<template>
    <div class="live-room-call-back">
        <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
        <Modal v-model="showModalStatus" :title="title" @on-ok="editStatus('priceInfoValidate')" :loading="loading">
            <Form :model="priceInfo" ref="priceInfoValidate" :rules="priceInfoValidate" action="javascript:void(0)">
                <FormItem label="审核状态" prop="status">
                    <Select v-model="priceInfo.status" clearable style="width:80px" placeholder="请选择状态...">
                        <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="备注" prop="comment">
                    <Input v-model="priceInfo.comment" placeholder="备注..."></Input>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: "live-room-call-back",
        data() {
            // const validateStatus = (rule, value, callback) => {
            //     if (this.dataInfo.custom_made_cate_id === '') {
            //         callback(new Error('请选择审核状态'));
            //     } else {
            //         callback();
            //     }
            // };
            return {
                title:'',
                statusList: [
                    {id: 1, name: "通过"},
                    {id: 0, name: "待审核"},
                    {id: -1, name: "不通过"}
                ],
                loading: true,
                dataloading: true,
                showModalStatus: false,
                list: [
                    {
                        title: 'Id',
                        key: 'id',
                        fixed: 'left',
                        width: 90
                    },
                    {
                        title: '查看',
                        key: 'url',
                        minWidth: 200,
                        render: (h, params) => {
                            return h('a', {
                                attrs: {
                                    href: params.row.url,
                                    target: '_black'
                                }
                            }, '播放')
                        }
                    },
                    {
                        title: '审核状态',
                        width: 100,
                        render: (h, params) => {
                            return h(
                                "tag",
                                {
                                    props: {
                                        color: params.row.status == "1" ? "geekblue" : (params.row.status == 0) ? 'orange' : "red"
                                    }
                                },
                                params.row.status == "1" ? "通过" : params.row.status == 0 ? '待审核' : "未通过"
                            );
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        width: 150,
                        align: 'left',
                        fixed: 'right',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    style: {
                                        marginRight: '8px'
                                    },
                                    props: {
                                        type: 'warning',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.comment(params.row.id)
                                        }
                                    }
                                }, '留言'),
                                h('Button', {
                                    style: {
                                        marginRight: '8px'
                                    },
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.review(params.index, params.row.id, params.row.status, params.row.comment)
                                        }
                                    }
                                }, '审核'),
                            ]);
                        }
                    }
                ],
                tablelist: [],
                id: 0,
                priceInfo: {
                    id: 0,
                    comment: '',
                    status: 0,
                },
                priceInfoValidate: {
                    // price: [
                    //     {required: true, message: '价格区间必须填写', trigger: 'blur'}
                    // ],
                    // status: [
                    //     {required: true, validator: validateStatus, trigger: 'change'}
                    // ],

                },
            }
        },
        created: function () {
            this.id = this.$route.params.id;
            // 取数据
            this.getTableList();
        },
        components: {},
        methods: {
            getTableList: function () {
                this.$api.liveroom.callbacklist({id: this.id}).then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                        this.tablelist = res.result;
                        this.$Message.success(res.msg);
                    }
                });
                return;
            },
            review(index, id, status, comment) {
                this.title = "审核";
                this.priceInfo = {
                    id: 0,
                    comment: comment,
                    status: status,
                };
                this.priceInfo.id = id;
                this.showModalStatus = !this.showModalStatus;
            },
            //评论
            comment(id){
                this.$router.push('/callback/comment/' + id);
            },
            //审核
            editStatus(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.$api.liveroom.status(this.priceInfo).then(res => {
                            if (res.code == 200) {
                                this.getTableList();
                            }
                            this.loading = false;
                            this.$nextTick(() => {
                                this.loading = true;
                            });
                            this.showModalStatus = !this.showModalStatus;
                        });
                    } else {
                        this.$Message.error('请检查输入的信息是否正确！');
                        this.loading = false
                        this.$nextTick(() => {
                            this.loading = true;
                        });
                    }
                })

            },

        },
    }
</script>

<style scoped>

</style>